import React, {  } from "react";

import {
  Card
} from '@lockerpm/design';

import commonComponents from "../../../components/common";

import images from "../../../assets/images";

const AuthCard = (props) => {
  const { AuthLogo } = commonComponents;
  const { AuthBgImage } = images;

  const {
    className = '',
    paddingTop = 36,
    cardWidth = 400,
    top = <></>,
    children = <></>,
    other = <></>
  } = props;

  return (
    <div
      className={`auth-card flex justify-center ${className}`}
      style={{
        backgroundImage: `url(${AuthBgImage})`,
        backgroundRepeat: 'no-repeat',
        paddingTop: paddingTop,
        backgroundPositionY: '-260px',
        backgroundPositionX: 'center',
        backgroundSize: '768px'
      }}
    >
      <div style={{ width: cardWidth }}>
        {top}
        <AuthLogo
          className={'mb-2'}
        />
        <div className="flex items-center justify-center">
          <Card
            className="bg-transparent w-full"
            bordered={false}
            style={{
              boxShadow: 'none'
            }}
            bodyStyle={{
              padding: 16
            }}
          >
            {children}
          </Card>
        </div>
        {other}
      </div>
    </div>
  );
}

export default AuthCard;